import './modules/swiper';
import './modules/howWorks';
import './modules/faq';
import './modules/header';
import './modules/animals';
import './modules/single-animal';
import './modules/support-form';

// Initialize any JavaScript functionality here
document.addEventListener('DOMContentLoaded', () => {
  console.log('App initialized');
});
